import React from 'react';

function convertToRMB(amount, currency, exchangeRates) {
  if (currency === '¥' || currency === 'CNY') return amount;
  if (currency === '$' || currency === 'USD') return amount * (exchangeRates.USD || 7.19);
  return amount;
}

function AccountSelector({ accounts, trades, selectedAccount, setSelectedAccount, exchangeRates }) {
  // 统计信息计算
  let currentBalance = 0;
  let totalReturn = 0;
  let maxDrawdown = 0;

  if (!selectedAccount) {
    // 所有账户汇总
    let totalInitial = 0;
    let accountBalances = {};
    accounts.forEach(acc => {
      const initial = convertToRMB(acc.capital, acc.currency, exchangeRates);
      totalInitial += initial;
      accountBalances[acc.name] = initial;
    });
    let totalBalance = totalInitial;
    let maxTotalBalance = totalBalance;
    const sortedTrades = [...trades].sort((a, b) => new Date(a.date) - new Date(b.date));
    sortedTrades.forEach(trade => {
      const acc = accounts.find(a => a.name === trade.account);
      if (!acc) return;
      const profitRMB = convertToRMB(trade.profit, acc.currency, exchangeRates);
      accountBalances[trade.account] += profitRMB;
      totalBalance = Object.values(accountBalances).reduce((sum, bal) => sum + bal, 0);
      maxTotalBalance = Math.max(maxTotalBalance, totalBalance);
    });
    const totalProfit = totalBalance - totalInitial;
    currentBalance = totalBalance;
    totalReturn = totalInitial > 0 ? (totalProfit / totalInitial) * 100 : 0;
    maxDrawdown = maxTotalBalance > 0 ? ((maxTotalBalance - totalBalance) / maxTotalBalance) * 100 : 0;
  } else {
    // 单账户
    const acc = accounts.find(a => a.name === selectedAccount);
    if (acc) {
      let balance = acc.capital;
      let maxBalance = balance;
      const filteredTrades = trades.filter(t => t.account === selectedAccount).sort((a, b) => new Date(a.date) - new Date(b.date));
      filteredTrades.forEach(trade => {
        balance += trade.profit;
        maxBalance = Math.max(maxBalance, balance);
      });
      const totalProfit = balance - acc.capital;
      currentBalance = balance;
      totalReturn = acc.capital > 0 ? (totalProfit / acc.capital) * 100 : 0;
      maxDrawdown = maxBalance > 0 ? ((maxBalance - balance) / maxBalance) * 100 : 0;
    }
  }

  return (
    <div className="section">
      <h2>账户选择</h2>
      <div style={{ marginBottom: 20 }}>
        <select value={selectedAccount} onChange={e => setSelectedAccount(e.target.value)}>
          <option value="">所有账户</option>
          {accounts.map(acc => (
            <option key={acc.name} value={acc.name}>{acc.name}</option>
          ))}
        </select>
        <div style={{ marginTop: 10 }}>
          <span style={{ marginRight: 20 }}>当前余额 <span id="currentBalance">¥{currentBalance.toFixed(2)}</span></span>
          <span style={{ marginRight: 20 }}>总收益率 <span id="totalReturn">{totalReturn.toFixed(2)}%</span></span>
          <span>最大回撤 <span id="maxDrawdown">{maxDrawdown.toFixed(2)}%</span></span>
        </div>
      </div>
    </div>
  );
}

export default AccountSelector; 